<template>
  <div class="extra-prodi-card">

    <!-- Dekorasi pojok -->
    <div class="deco deco--tl" aria-hidden="true">
      <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="30" cy="30" r="50" fill="#4489C6" opacity="0.12"/>
        <circle cx="10" cy="10" r="20" fill="#6DD5FA" opacity="0.18"/>
      </svg>
    </div>
    <div class="deco deco--br" aria-hidden="true">
      <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="90" cy="90" r="55" fill="#F0D25B" opacity="0.15"/>
        <circle cx="110" cy="110" r="22" fill="#DF654D" opacity="0.12"/>
      </svg>
    </div>

    <div class="card-content">

      <!-- Tombol Kembali -->
      <button class="btn-back" @click="$emit('back')" aria-label="Kembali ke halaman sebelumnya">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg>
        Kembali
      </button>

      <!-- Abby Header -->
      <div class="abby-header">
        <div class="abby-mascot">
          <img src="@/assets/pcu/2026/abby-smile-half.png" alt="Abby Mascot" class="abby-img"/>
        </div>
        <div class="abby-dialog">
          <h2 class="card-title">
            <span v-if="nickname">Btw, <span class="nickname-highlight">{{ nickname }}</span>… </span>ada pilihan jurusan lain?
          </h2>
          <p class="card-subtitle">
            Apakah kamu ada pilihan lain yang <strong>belum tersedia</strong> di daftar tadi?
            Ketikkan jurusannya dan kami akan cari — kalau tidak ketemu pun tidak apa,
            kamu tetap bisa menambahkannya! Maksimal <em>2 jurusan</em>.
          </p>
        </div>
      </div>

      <!-- Tag jurusan yang sudah ditambahkan -->
      <div v-if="selectedItems.length > 0" class="selected-tags" role="list" aria-label="Jurusan tambahan yang dipilih">
        <div
          v-for="(item, i) in selectedItems"
          :key="i"
          class="tag"
          :class="{ 'tag--api': item.id !== null, 'tag--custom': item.id === null }"
          role="listitem"
        >
          <span class="tag-icon">{{ item.id !== null ? '🎓' : '✏️' }}</span>
          <span class="tag-text">{{ item.name }}</span>
          <span class="tag-badge" :class="item.id !== null ? 'badge--list' : 'badge--custom'">
            {{ item.id !== null ? '' : 'custom' }}
          </span>
          <button class="tag-remove" @click="removeItem(i)" :aria-label="`Hapus ${item.name}`">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 162.6 56.6 43.5C43.3 29.9 23 29.9 9.8 43.5S-3.4 79.7 9.8 93.3L145.2 212.4 9.8 331.5c-13.3 13.6-13.3 35.8 0 49.4s35.2 13.6 48.5 0L192 261.4l135.4 119.1c13.3 13.6 35.2 13.6 48.5 0s13.3-35.8 0-49.4L240.8 212.4 376.2 93.3c11.3-13.6 9.5-33.8-4.1-45.1z"/></svg>
          </button>
        </div>
      </div>

      <!-- Hint kosong -->
      <div v-else class="empty-hint">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"/></svg>
        Belum ada jurusan tambahan. Ketikkan di bawah untuk menambahkan!
      </div>

      <!-- Input Autocomplete (tampil jika belum mencapai maks) -->
      <div v-if="selectedItems.length < 2" class="input-area" ref="inputAreaRef">
        <div class="input-wrapper" :class="{ 'has-error': errorMsg }">
          <span class="input-prefix-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
          </span>
          <input
            ref="inputRef"
            type="text"
            v-model="inputValue"
            @input="onInput"
            @focus="onFocus"
            @blur="onBlur"
            @keydown.enter.prevent="handleEnter"
            @keydown.escape="closeDrop"
            @keydown.down.prevent="moveHighlight(1)"
            @keydown.up.prevent="moveHighlight(-1)"
            @compositionstart="onCompositionStart"
            @compositionend="onCompositionEnd"
            :placeholder="selectedItems.length === 0 ? 'Cari atau ketik nama jurusan...' : 'Tambahkan satu lagi...'"
            autocomplete="off"
            aria-autocomplete="list"
            aria-haspopup="listbox"
            :aria-expanded="dropdownOpen"
          />
          <button v-if="inputValue" class="clear-btn" @click="clearInput" aria-label="Hapus teks">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 162.6 56.6 43.5C43.3 29.9 23 29.9 9.8 43.5S-3.4 79.7 9.8 93.3L145.2 212.4 9.8 331.5c-13.3 13.6-13.3 35.8 0 49.4s35.2 13.6 48.5 0L192 261.4l135.4 119.1c13.3 13.6 35.2 13.6 48.5 0s13.3-35.8 0-49.4L240.8 212.4 376.2 93.3c11.3-13.6 9.5-33.8-4.1-45.1z"/></svg>
          </button>
        </div>

        <!-- Error message -->
        <p v-if="errorMsg" class="error-msg" role="alert">{{ errorMsg }}</p>

        <!-- Dropdown Autocomplete -->
        <div
          v-if="dropdownOpen && (filteredSuggestions.length > 0 || canAddCustom)"
          class="autocomplete-drop"
          role="listbox"
          @click.stop.prevent
        >
          <button
            v-for="(s, idx) in filteredSuggestions"
            :key="s.id"
            class="drop-item"
            :class="{ highlighted: highlightIndex === idx }"
            @click.stop.prevent="selectSuggestion(s)"
            role="option"
            :aria-selected="highlightIndex === idx"
          >
            <span class="drop-item-icon">🎓</span>
            <span class="drop-item-text" v-html="highlight(s.name)"></span>
            <!-- <span class="drop-item-badge">dari daftar</span> -->
          </button>

          <button
            v-if="canAddCustom"
            class="drop-item drop-item--custom"
            :class="{ highlighted: highlightIndex === filteredSuggestions.length }"
            @click.stop.prevent="addCustom"
            role="option"
            :aria-selected="highlightIndex === filteredSuggestions.length"
          >
            <span class="drop-item-icon">✏️</span>
            <span class="drop-item-text">Tambahkan <strong>"{{ inputValue.trim() }}"</strong> secara manual</span>
          </button>

          <p v-if="filteredSuggestions.length === 0 && !canAddCustom" class="drop-empty">
            Jurusan tidak ditemukan.
          </p>
        </div>
      </div>

      <!-- Maksimal tercapai -->
      <p v-else class="max-notice">
        ✅ Kamu sudah menambahkan 2 jurusan. Hapus salah satu untuk mengganti.
      </p>

      <!-- Tombol Aksi -->
      <div class="action-buttons">
        <button class="btn-skip" @click="$emit('next', [])">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>
          Lewati
        </button>
        <button
          class="btn-next"
          :class="{ 'btn-active': selectedItems.length > 0 }"
          :disabled="selectedItems.length === 0"
          @click="handleSubmit"
        >
          Lanjutkan
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg>
        </button>
      </div>

      <p class="note-text">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"/></svg>
        Langkah ini opsional. Jurusan yang kamu tulis akan disimpan bersama hasil akhirmu.
      </p>

    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { containsProfanity } from '@/utils/profanityList.js';
import { expandSearchTerms } from '@/utils/searchAliases.js';

const props = defineProps({
  prodis: {
    type: Object,
    default: () => ({})
  },
  nickname: {
    type: String,
    default: ''
  },
  initialItems: {
    // Array of id-strings (from API) or custom name-strings
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['next', 'back']);

// --- Reactive state ---
const inputValue    = ref('');
const searchQuery   = ref(''); // tracks live input incl. during IME composition
const isComposing   = ref(false);
// Restore previous selections: if the value matches a known prodi ID, map it to
// { id, name }; otherwise treat it as a custom entry.
const selectedItems = ref(
  props.initialItems.map(val => {
    const name = props.prodis[val];
    return name ? { id: String(val), name } : { id: null, name: String(val) };
  })
);
const dropdownOpen  = ref(false);
const highlightIndex = ref(-1);
const errorMsg      = ref('');
const inputRef      = ref(null);
const inputAreaRef  = ref(null);

// --- Computed ---

/** Suggestions difilter dari prodiList, dengan dukungan alias bahasa Indonesia */
const filteredSuggestions = computed(() => {
  const query = searchQuery.value.trim().toLowerCase();
  if (!query) return [];

  const terms = expandSearchTerms(query);

  const results = [];
  for (const [id, name] of Object.entries(props.prodis)) {
    const nameLower = name.toLowerCase();
    if (terms.some(term => nameLower.includes(term))) {
      results.push({ id, name });
    }
    if (results.length >= 8) break;
  }
  return results;
});

/** Boleh tambah kustom jika input tidak kosong, cukup panjang, dan belum dipilih */
const canAddCustom = computed(() => {
  const query = searchQuery.value.trim();
  if (query.length < 2) return false;
  const already = selectedItems.value.some(
    item => item.name.toLowerCase() === query.toLowerCase()
  );
  return !already;
});

/** Jumlah item di dropdown (untuk navigasi keyboard) */
const dropdownItemCount = computed(() =>
  filteredSuggestions.value.length + (canAddCustom.value ? 1 : 0)
);

// --- Handlers ---

// onInput reads e.target.value directly — this bypasses Vue's IME composition
// guard that prevents v-model from updating during active composition on mobile.
function onInput(e) {
  searchQuery.value = e.target.value;
  errorMsg.value = '';
  highlightIndex.value = -1;
  dropdownOpen.value = searchQuery.value.trim().length > 0;
}

function onCompositionStart() {
  isComposing.value = true;
}

// compositionend fires after the mobile keyboard commits a word (e.g. predictive).
// e.target.value now holds the fully committed text — sync searchQuery and re-open.
function onCompositionEnd(e) {
  isComposing.value = false;
  searchQuery.value = e.target.value;
  errorMsg.value = '';
  highlightIndex.value = -1;
  dropdownOpen.value = searchQuery.value.trim().length > 0;
}

function onFocus() {
  if (inputValue.value.trim().length > 0) dropdownOpen.value = true;
}

function onBlur() {
  // 350ms: enough for the browser's native click event (~300ms after touchstart)
  // to fire and trigger item selection before the dropdown closes.
  setTimeout(() => { dropdownOpen.value = false; }, 350);
}

function closeDrop() {
  dropdownOpen.value = false;
  highlightIndex.value = -1;
}

function clearInput() {
  inputValue.value = '';
  searchQuery.value = '';
  errorMsg.value = '';
  dropdownOpen.value = false;
  highlightIndex.value = -1;
  inputRef.value?.focus();
}

function moveHighlight(dir) {
  if (!dropdownOpen.value) return;
  const max = dropdownItemCount.value - 1;
  highlightIndex.value = Math.max(-1, Math.min(max, highlightIndex.value + dir));
}

function handleEnter() {
  if (highlightIndex.value >= 0 && highlightIndex.value < filteredSuggestions.value.length) {
    selectSuggestion(filteredSuggestions.value[highlightIndex.value]);
  } else if (highlightIndex.value === filteredSuggestions.value.length && canAddCustom.value) {
    addCustom();
  } else if (canAddCustom.value) {
    addCustom();
  }
}

/** Menyorot bagian teks yang sesuai dengan query */
function highlight(name) {
  const query = searchQuery.value.trim();
  if (!query) return name;
  const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return name.replace(new RegExp(`(${escaped})`, 'gi'), '<mark>$1</mark>');
}

// Guard against tap-through: ignore submit calls that arrive within 400ms
// of the last dropdown selection (mobile synthesizes click after pointerdown).
const lastSelectionTime = ref(0);

function addItem(item) {
  if (containsProfanity(item.name)) {
    errorMsg.value = 'Input mengandung kata yang tidak pantas. Mohon gunakan bahasa yang sopan ya! 🙏';
    return false;
  }
  if (selectedItems.value.some(s => s.name.toLowerCase() === item.name.toLowerCase())) {
    errorMsg.value = 'Jurusan ini sudah kamu tambahkan.';
    return false;
  }
  if (selectedItems.value.length >= 2) {
    errorMsg.value = 'Maksimal 2 jurusan tambahan.';
    return false;
  }
  selectedItems.value.push(item);
  lastSelectionTime.value = Date.now();
  inputValue.value = '';
  searchQuery.value = '';
  dropdownOpen.value = false;
  highlightIndex.value = -1;
  errorMsg.value = '';
  return true;
}

function selectSuggestion(s) {
  addItem({ id: s.id, name: s.name });
}

function addCustom() {
  const name = searchQuery.value.trim();
  if (!name) return;
  addItem({ id: null, name });
}

function removeItem(i) {
  selectedItems.value.splice(i, 1);
  errorMsg.value = '';
  // Fokus lagi ke input setelah hapus tag
  setTimeout(() => inputRef.value?.focus(), 100);
}

function handleSubmit() {
  if (Date.now() - lastSelectionTime.value < 400) return; // tap-through guard
  // ID string dari API, atau teks kustom string
  const output = selectedItems.value.map(item =>
    item.id !== null ? item.id : item.name
  );
  emit('next', output);
}

// Tutup dropdown saat klik di luar komponen
function handleClickOutside(e) {
  if (inputAreaRef.value && !inputAreaRef.value.contains(e.target)) {
    closeDrop();
  }
}

onMounted(() => {
  document.addEventListener('mousedown', handleClickOutside);
  // Fix 5: touchstart needed for outside-tap detection on mobile
  document.addEventListener('touchstart', handleClickOutside, { passive: true });
});

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside);
  document.removeEventListener('touchstart', handleClickOutside);
});
</script>

<style scoped>
.extra-prodi-card {
  background: #ffffff;
  border-radius: 28px;
  padding: 2.5rem;
  width: 100%;
  max-width: 620px;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.12);
  position: relative;
  z-index: 2; /* pastikan card (beserta dropdown-nya) tampil di atas footer */
  overflow: visible; /* dropdown harus bisa overflow */
  border: 1px solid rgba(255, 255, 255, 0.7);
  animation: card-in 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) both;
}

@keyframes card-in {
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0)    scale(1); }
}

/* Dekorasi sudut */
.deco {
  position: absolute;
  width: 160px;
  height: 160px;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;
}
.deco--tl { top: -40px; left: -40px; border-radius: 28px 0 0 0; }
.deco--br { bottom: -40px; right: -40px; border-radius: 0 0 28px 0; }

.card-content {
  position: relative;
  z-index: 1;
}

/* ============================
   ABBY HEADER
   ============================ */
.abby-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.5rem;
}

.abby-mascot { flex-shrink: 0; }

.abby-img {
  width: 130px;
  object-fit: contain;
  display: block;
  animation: float-abby 3s ease-in-out infinite;
  -webkit-mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 88%, transparent 100%);
}

@keyframes float-abby {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(-8px); }
}

.abby-dialog {
  position: relative;
  background: #ffffff;
  border: 2px solid #26488A;
  border-radius: 16px;
  padding: 14px 16px;
  width: 100%;
  box-shadow: 4px 4px 0 #26488A;
  display: flex;
  flex-direction: column;
  gap: 4px;
  animation: pop-in 0.4s ease;
}

/* Ekor atas bubble ke arah Abby */
.abby-dialog::before {
  content: "";
  position: absolute;
  top: -12px;
  left: 50px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #26488A;
}

.abby-dialog::after {
  content: "";
  position: absolute;
  top: -10px;
  left: 52px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}

@keyframes pop-in {
  0%   { transform: scale(0.95); opacity: 0; }
  100% { transform: scale(1);    opacity: 1; }
}

.card-title {
  color: #26488A;
  font-size: 1.35rem;
  font-weight: 800;
  margin: 0 0 0.3rem 0;
  text-align: left;
}

.nickname-highlight { color: #DF654D; }

.card-subtitle {
  color: #555;
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0;
  text-align: left;
}

.card-subtitle strong { color: #26488A; }
.card-subtitle em     { color: #2980B9; font-style: normal; font-weight: 600; }

/* ============================
   SELECTED TAGS
   ============================ */
.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.65rem 0.45rem 0.55rem;
  border-radius: 50px;
  font-size: 0.82rem;
  font-weight: 600;
  animation: tag-in 0.25s ease both;
}

@keyframes tag-in {
  from { opacity: 0; transform: scale(0.85); }
  to   { opacity: 1; transform: scale(1); }
}

.tag--api {
  background: linear-gradient(135deg, #26488A, #4489C6);
  color: #fff;
  box-shadow: 0 3px 10px rgba(38, 72, 138, 0.25);
}

.tag--custom {
  background: #fff8ec;
  color: #7c5a00;
  border: 1.5px solid #ffe099;
  box-shadow: 0 2px 6px rgba(224, 169, 0, 0.12);
}

.tag-icon  { font-size: 0.9rem; line-height: 1; }
.tag-text  { max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

.tag-badge {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  padding: 0.15rem 0.45rem;
  border-radius: 50px;
  white-space: nowrap;
}

.badge--list   { background: rgba(255,255,255,0.25); color: #fff; }
.badge--custom { background: rgba(224,169,0,0.18); color: #7c5a00; }

.tag-remove {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;
  padding: 0;
}

.tag--api    .tag-remove { background: rgba(255,255,255,0.2); color: #fff; }
.tag--custom .tag-remove { background: rgba(0,0,0,0.06); color: #7c5a00; }

.tag--api    .tag-remove:hover { background: rgba(255,255,255,0.35); }
.tag--custom .tag-remove:hover { background: rgba(0,0,0,0.12); }

.tag-remove svg {
  width: 9px;
  height: 9px;
  fill: currentColor;
  pointer-events: none;
}

/* ============================
   EMPTY HINT
   ============================ */
.empty-hint {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  padding: 0.65rem 1rem;
  background: #f4f8fc;
  border-radius: 12px;
  border-left: 3px solid #4489C6;
  font-size: 0.82rem;
  color: #7f8c8d;
}

.empty-hint svg {
  width: 14px;
  height: 14px;
  fill: #4489C6;
  flex-shrink: 0;
}

/* ============================
   INPUT AREA & AUTOCOMPLETE
   ============================ */
.input-area {
  position: relative;
  margin-bottom: 1rem;
}

.input-wrapper {
  display: flex;
  align-items: center;
  background: #f2f2f3;
  border: 2px solid #e0e0e0;
  border-radius: 14px;
  padding-left: 12px;
  transition: border-color 0.25s, box-shadow 0.25s;
}

.input-wrapper:focus-within {
  border-color: #4489C6;
  box-shadow: 0 0 0 3px rgba(68, 137, 198, 0.12);
}

.input-wrapper.has-error {
  border-color: #DF654D;
  animation: shake 0.4s;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25%       { transform: translateX(-5px); }
  50%       { transform: translateX(5px); }
  75%       { transform: translateX(-5px); }
}

.input-prefix-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: 8px;
}

.input-prefix-icon svg {
  width: 15px;
  height: 15px;
  fill: #95a5a6;
}

input[type="text"] {
  flex: 1;
  padding: 13px 8px;
  border: none;
  background: transparent;
  font-family: 'Epilogue', sans-serif;
  font-size: 0.95rem;
  color: #2c3e50;
  outline: none;
}

input[type="text"]::placeholder { color: #bdc3c7; }

.clear-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-right: 8px;
  border-radius: 50%;
  border: none;
  background: #e0e0e0;
  color: #777;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s;
}

.clear-btn:hover { background: #c9c9c9; }

.clear-btn svg {
  width: 9px;
  height: 9px;
  fill: currentColor;
  pointer-events: none;
}

.error-msg {
  color: #DF654D;
  font-size: 0.8rem;
  font-weight: 500;
  margin: 0.4rem 0 0 0.5rem;
}

/* ---- Dropdown ---- */
.autocomplete-drop {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid #dce9f5;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  max-height: 260px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  z-index: 9999;
  animation: drop-in 0.15s ease both;
}

@keyframes drop-in {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.drop-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.7rem 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: 'Epilogue', sans-serif;
  font-size: 0.88rem;
  color: #2c3e50;
  transition: background 0.15s;
  border-bottom: 1px solid #f0f4f8;
}

.drop-item:last-child { border-bottom: none; }

.drop-item:hover,
.drop-item.highlighted {
  background: #edf4fb;
}

.drop-item--custom {
  border-top: 1.5px dashed #dce9f5;
  color: #4e5c6a;
  font-style: italic;
}

.drop-item--custom:hover,
.drop-item--custom.highlighted {
  background: #fff8ec;
}

.drop-item-icon {
  font-size: 1rem;
  flex-shrink: 0;
}

.drop-item-text {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Highlight in autocomplete results */
.drop-item-text :deep(mark) {
  background: #ffeaa0;
  color: #26488A;
  border-radius: 2px;
  padding: 0 1px;
}

.drop-item-text strong {
  color: #26488A;
  font-style: normal;
}

.drop-item-badge {
  font-size: 0.65rem;
  font-weight: 700;
  padding: 0.12rem 0.45rem;
  border-radius: 50px;
  background: #e8f3fc;
  color: #26488A;
  white-space: nowrap;
  flex-shrink: 0;
}

.drop-empty {
  padding: 0.75rem 1rem;
  color: #95a5a6;
  font-size: 0.85rem;
  text-align: center;
  margin: 0;
}

/* ============================
   MAX NOTICE
   ============================ */
.max-notice {
  font-size: 0.82rem;
  color: #2980B9;
  font-weight: 500;
  margin-bottom: 1rem;
  text-align: center;
  padding: 0.5rem 1rem;
  background: #e8f3fc;
  border-radius: 10px;
}

/* ============================
   ACTION BUTTONS
   ============================ */
.action-buttons {
  display: flex;
  gap: 0.75rem;
  margin-top: 1.5rem;
  justify-content: center;
}

.btn-skip,
.btn-next {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.8rem 1.75rem;
  border-radius: 50px;
  font-family: 'Epilogue', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-skip svg,
.btn-next svg {
  width: 12px;
  height: 12px;
  fill: currentColor;
}

.btn-skip {
  background: transparent;
  border: 2px solid #bdc3c7;
  color: #7f8c8d;
}

.btn-skip:hover {
  border-color: #95a5a6;
  color: #555;
  transform: translateY(-2px);
}

.btn-next {
  background: #bdc3c7;
  border: 2px solid #bdc3c7;
  color: #fff;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-next.btn-active {
  background: linear-gradient(135deg, #26488A, #4489C6);
  border-color: transparent;
  cursor: pointer;
  opacity: 1;
  box-shadow: 0 5px 18px rgba(38, 72, 138, 0.3);
}

.btn-next.btn-active:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(38, 72, 138, 0.4);
}

.btn-next.btn-active:active { transform: translateY(0); }

/* ============================
   TOMBOL KEMBALI
   ============================ */
.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.85rem 0.35rem 0.6rem;
  background: transparent;
  border: 1.5px solid #dce9f5;
  border-radius: 50px;
  color: #4489C6;
  font-family: 'Epilogue', sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 1rem;
}

.btn-back svg {
  width: 9px;
  height: 9px;
  fill: currentColor;
  flex-shrink: 0;
}

.btn-back:hover {
  background: #edf4fb;
  border-color: #4489C6;
  color: #26488A;
  transform: translateX(-2px);
}

/* ============================
   NOTE TEKS
   ============================ */
.note-text {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  justify-content: center;
  margin-top: 1.25rem;
  font-size: 0.75rem;
  color: #95a5a6;
  text-align: center;
  line-height: 1.5;
}

.note-text svg {
  width: 12px;
  height: 12px;
  fill: currentColor;
  flex-shrink: 0;
  margin-top: 2px;
}

/* ============================
   RESPONSIVE
   ============================ */
@media (max-width: 480px) {
  .extra-prodi-card {
    padding: 1.75rem 1.25rem;
    border-radius: 20px;
  }

  .card-title { font-size: 1.2rem; }

  .action-buttons {
    flex-direction: column-reverse;
  }

  .btn-skip,
  .btn-next {
    justify-content: center;
  }

  .tag-text { max-width: 140px; }
}
</style>
